export const NavbarItems = [
    {
        titile : 'Home',
        url : '/'

    },
    {
        titile : 'About',
        url : '/about'

    },
    {
        titile : 'Skills',
        url : '/skills'

    },
    {
        titile : 'Projects',
        url : '/projects'

    },
    {
        titile : 'Contact',
        url : '/contact'

    },
]